import axiosPrivate from './axiosPrivate';

const catalogo = () => {
  return axiosPrivate.get('culminacion-laboral/catalogo').then((r) => r.data);
};

const usuariosOpciones = () => {
  return axiosPrivate.get('culminacion-laboral/usuarios-opciones').then((r) => r.data);
};

const listar = (params = {}) => {
  return axiosPrivate.get('culminacion-laboral', { params }).then((r) => r.data);
};

const crear = (payload) => {
  return axiosPrivate.post('culminacion-laboral', payload).then((r) => r.data);
};

const actualizar = (payload) => {
  return axiosPrivate.put('culminacion-laboral', payload).then((r) => r.data);
};

const subirArchivo = (id, campo, archivo, usuario_id) => {
  const fd = new FormData();
  fd.append('id', id);
  fd.append('campo', campo);
  fd.append('archivo_culminacion_laboral', archivo);
  fd.append('usuario_id', usuario_id);
  return axiosPrivate.post('guardarDocumentoCulminacionLaboral', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export default {
  catalogo,
  usuariosOpciones,
  listar,
  crear,
  actualizar,
  subirArchivo,
};
